
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/google-colab-for-kids",
      function () {
        return require("private-next-pages/courses/google-colab-for-kids.tsx");
      }
    ]);
  